import React from 'react'
import 'App.css'
import PrivateRoutes from 'PrivateRoutes'
import SnackbarAlert from 'components/ui/snackbar/SnackbarAlert'
import { SnackbarProvider } from 'components/ui/snackbar/context/Snackbar'
import { HashRouter } from 'react-router-dom'

function App() {
  return (
    <HashRouter basename="/">
      <SnackbarProvider>
        <SnackbarAlert />
        <PrivateRoutes />
      </SnackbarProvider>
    </HashRouter>
  )
}

export default App
